'use client';

// Shared chrome for activate / forgot / reset — matches login visual language
// (logo + form column) without Google GIS / Materialize carousel scripts.

import Link from 'next/link';
import type { ReactNode } from 'react';

type AuthChromeProps = {
  webDomain: string;
  children: ReactNode;
};

export function AuthChrome({ webDomain, children }: AuthChromeProps) {
  return (
    <div className="container">
      <Link href={webDomain || '/'} className="kw-logo-right">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className="top-logo-mobile"
          alt="KudosWall Pro Logo"
          src="/login-assets/images/pro-logo-teal.png"
          height={63}
        />
      </Link>

      <div className="left-section col-md-7">
        <div>
          <Link href={webDomain || '/'} className="kw-logo">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              className="top-logo"
              alt="KudosWall Pro Logo"
              src="/login-assets/images/pro-logo-teal.png"
              height={63}
            />
          </Link>
          <div className="contents">
            <h5>Secure access to your KudosWall account</h5>
            <p>
              Activate your account, recover your password, or set a new one — then continue
              building AI-optimized resumes and career tools trusted by job seekers worldwide.
            </p>
          </div>
        </div>
        <div className="features-sections">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/login-assets/images/pana.svg"
            alt=""
            className="features-imgs"
            width={320}
            height={120}
            loading="eager"
            decoding="async"
          />
        </div>
      </div>

      <div className="right-section col-md-7">
        <div className="writing_pro_resumes_sign new_pro_sign_in">{children}</div>
      </div>
    </div>
  );
}
